<template>
    <section class="full-background-section">
      <div class="content-container">
        <img src="../assets/periogard/Perio 250mL.png" alt="Imagen izquierda" class="left-imagen" />
        <img src="../assets/periogard/Perio 2L.png" alt="Imagen central" class="center-image" />
        <img src="../assets/periogard/Cepillo_1.png" alt="Imagen derecha" class="side-image" />
        <img src="../assets/periogard/Sello.png" alt="Imagen encima de la derecha" class="top-right-image" />
        <img src="../assets/periogard/Base.png" alt="Imagen inferior" class="bottom-image" />
        <img src="../assets/periogard/Crema.png" alt="Imagen encima de Base.png" class="above-bottom-image" />
        <img src="../assets/periogard/regimen.png" alt="Imagen esquina superior izquierda" class="top-left-image" />
        <img src="../assets/periogard/Claim_1.png" alt="Imagen adicional en la parte inferior" class="bottom-extra-image" />
        <slot></slot>
      </div>
    </section>
  </template>
  
  <script>
  import { onMounted } from "vue";
  import { gsap } from "gsap";
  import { ScrollTrigger } from "gsap/ScrollTrigger";
  import { MotionPathPlugin } from "gsap/MotionPathPlugin";
  
  gsap.registerPlugin(ScrollTrigger, MotionPathPlugin);
  
  export default {
    name: "PerioGardRegimen",
    setup() {
      onMounted(() => {
        gsap.timeline({
          scrollTrigger: {
            trigger: ".full-background-section",
            start: "20% bottom", // 🔥 Inicia cuando el usuario ha hecho 10% de scroll
            end: "45% center",
            scrub: 14, // 🔥 Controla el tiempo con el scroll sin ser exagerado
          },
        })
          .from(".left-imagen", {
            motionPath: {
              path: [{ x: -1500, y: -880 }, { x: 0, y: 0 }], // 🔥 Recorrido largo pero sin exceso
              curviness: 4, // 🔥 Movimiento más natural
            },
            opacity: 0,
            duration: 60, // 🔥 Lento pero no exagerado
            ease: "power1.out",
          })
          .from(
            ".center-image",
            {
              motionPath: {
                path: [{ x: 0, y: -880 }, { x: 0, y: 0 }],
                curviness: 4,
              },
              opacity: 0,
              duration: 60,
              ease: "power1.out",
            },
            "-=59" // 🔥 Un leve solapamiento para continuidad
          )
          .from(
            ".side-image",
            {
              motionPath: {
                path: [{ x: 2000, y: -880 }, { x: 0, y: 0 }],
                curviness: 4,
              },
              opacity: 0,
              duration: 60,
              ease: "power1.out",
            },
            "-=59"
          )
          .from(
            ".above-bottom-image",
            {
              motionPath: {
                path: [{ x: 0, y: 1500 }, { x: 0, y: 0 }],
                curviness: 4,
              },
              opacity: 0,
              duration: 60,
              ease: "power1.out",
            },
            "-=59"
          );
      });
  
      return {};
    },
  };
  
  </script>
  
  <style scoped>
  .full-background-section {
    width: 100%;
    height: 120vh; /* Ocupa toda la altura de la pantalla */
    background-image: url('../assets/periogard/basefondo.png'); /* Ruta de la imagen de fondo */
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
  }
  
  .content-container {
    width: 90%;
    height: 90%;
    /* background: rgba(150, 140, 140, 0.342); */ /* Fondo semitransparente opcional */
    border-radius: 10px; /* Bordes redondeados opcional */
    display: flex;
    justify-content: center; /* Mantiene la imagen central en su lugar */
    align-items: center;
    text-align: center;
    position: relative;
  }
  
  /* Imagen central dentro del contenedor */
  .center-image {
    max-width: 50%;
    max-height: 70%;
    object-fit: contain;
    position: relative;
    z-index: 1; /* Asegura que la imagen central no se vea afectada */
    position: absolute;
    top: calc(-17% + 200px);
  }
  
  /* Imagen lateral al lado derecho, tocando el borde derecho sin afectar la imagen central */
  .side-image {
    max-width: 25%;
    max-height: 70%;
    object-fit: contain;
    position: absolute;
    right: calc(-1% + 206px);
    top: calc(18% + 200px);
    transform: translateY(-50%);
    z-index: 2;
  }
  
  /* Nueva imagen encima de la imagen derecha, centrada verticalmente */
  .top-right-image {
    max-width: 14%;
    max-height: 60%;
    object-fit: contain;
    position: absolute;
    /* right: calc(2% + 200px);
    top: calc(34% + 200px); */
    left: 0;
    transform: translateY(-50%);
    z-index: 3;
  }
  
  /* Imagen lateral al lado izquierdo, tocando el borde izquierdo sin afectar la imagen central */
  .left-imagen {
    max-width: 25%;
    max-height: 70%;
    object-fit: contain;
    position: absolute;
    left: calc(-1% + 200px);
    top: calc(23% + 200px);
    transform: translateY(-50%);
    z-index: 2;
  }
  
  /* Imagen en la parte inferior, centrada horizontalmente y tocando el borde inferior */
  .bottom-image {
    max-width: 65%;
    max-height: 50%;
    object-fit: contain;
    position: absolute;
    bottom: calc(-16% + 200px); /* Toca el borde inferior */
    left: 50%; /* Centrada horizontalmente */
    transform: translateX(-50%);
  }
  
  /* Nueva imagen encima de Base.png */
  .above-bottom-image {
    max-width: 50%; /* Tamaño ajustable */
    max-height: 45%;
    object-fit: contain;
    position: absolute;
    bottom: calc(-5% + 200px); /* Posicionada encima de Base.png */
    left: 50%; /* Centrada horizontalmente */
    transform: translateX(-50%);
    z-index: 2; /* Se asegura de estar encima de Base.png */
  }
  
  .top-left-image {
    max-width: 25%;
    max-height: 60%;
    object-fit: contain;
    position: absolute;
    left: 0%;
    top: 0%;
    z-index: 3;
  }
  
  .bottom-extra-image {
  max-width: 72%;
  max-height: 50%;
  object-fit: contain;
  position: absolute;
  bottom: calc(-22% + 200px);
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
}


  /* Ajustes específicos para tablets horizontales */
  @media (max-width: 1024px) and (min-width: 768px) {
    .content-container {
      width: 95%;
      height: 85%;
    }
  
    .center-image {
      max-width: 50%;
    }
  
    .side-image, .left-imagen {
      max-width: 20%;
    }
  
    .top-right-image {
      width: 14%;
    }
  
    .side-image {
      right: calc(3% + 206px);
    }
  
    /* Aumento del tamaño de Base.png y Crema.png en tablets */
    .bottom-image {
      max-width: 60%; /* Aumentamos el tamaño en tablets */
      max-height: 55%;
      bottom: calc(-18% + 200px);
    }
  
    .above-bottom-image {
      max-width: 46%; /* Aumentamos el tamaño de Crema.png en tablets */
      max-height: 50%;
      bottom: calc(-9% + 200px); /* Le damos más margen desde abajo */
    }
  }
  
  /* Ajustes para pantallas móviles */
  @media (max-width: 767px) {
    .full-background-section {
      height: 100vh;
    }
  
    .content-container {
      width: 95%;
      height: auto;
      padding: 20px;
      flex-direction: column; /* En móviles, las imágenes se apilan */
    }
  
    .center-image {
      max-width: 55%;
    }
  
    .side-image, .left-imagen, .top-right-image, .bottom-image, .above-bottom-image {
      max-width: 50%;
      position: static; /* En móviles, se apilan debajo */
      margin-top: 15px;
    }
  }
  </style>
  